import Icon from '../components/Icon';

const Weather35 = Icon(
  'weather-35',
  <>
    <path
      fillRule="evenodd"
      d="M11.192 1.25c-3.576 0-6.542 2.603-7.125 6.02a4.38 4.38 0 0 0-2.817 4.097 4.377 4.377 0 0 0 4.371 4.383h7.788l-1.069 1.977a.75.75 0 0 0 1.32.713l1.454-2.69h2.052c3.086 0 5.584-2.51 5.584-5.6 0-3.06-2.45-5.55-5.495-5.598a7.22 7.22 0 0 0-6.063-3.302m5.974 13a4.09 4.09 0 0 0 4.084-4.1 4.09 4.09 0 0 0-4.36-4.09.75.75 0 0 1-.705-.38 5.72 5.72 0 0 0-4.993-2.93c-2.966 0-5.408 2.263-5.7 5.165a.75.75 0 0 1-.565.653 2.88 2.88 0 0 0-2.177 2.799 2.877 2.877 0 0 0 2.871 2.883z"
      clipRule="evenodd"
    />
    <path d="M17.023 17.34a.75.75 0 0 1 .303 1.017L15.66 21.44a.75.75 0 1 1-1.32-.713l1.667-3.084a.75.75 0 0 1 1.016-.303M8 19a1 1 0 1 0 0-2 1 1 0 0 0 0 2M7 21a1 1 0 1 1-2 0 1 1 0 0 1 2 0M10 22a1 1 0 1 0 0-2 1 1 0 0 0 0 2" />
  </>
);

export default Weather35;
